import { render, staticRenderFns } from "./OnlineCulture.vue?vue&type=template&id=2a7f1984&"
import script from "./OnlineCulture.vue?vue&type=script&lang=ts&"
export * from "./OnlineCulture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports